const actionTypes = [
  "",
  "Melee",
  "Range",
  "Spell",
  "Power",
  "Special",
  "Potion",
  "Magic Item"
];

const itemTypes = [
  "Currency",
  "Weapon",
  "Armor",
  "Gear",
  "Magic Item",
  "Consumable",
  "Vehicle"
];

const spellSchools = [
  "",
  "Abjuration",
  "Conjuration",
  "Divination",
  "Enchantment",
  "Evocation",
  "Illusion",
  "Necromancy",
  "Transmutation"
];

const ruleTypes = ["Ability", "Feat"];
const ruleTypesPlural = { Ability: "Abilities", Feat: "Feats" };

const getAttribute = (attribute, attributes) => {
  return attributes.find(x => x.name === attribute);
};

const getAttributeBonus = attribute => {
  let total = 0;
  if (Number.isFinite(attribute.temp)) {
    total = Math.floor((attribute.temp - 10) / 2);
  } else if (Number.isFinite(attribute.score)) {
    total = Math.floor((attribute.score - 10) / 2);
  }
  return total;
};

const getTotalHitPoints = hitPoints => {
  let hp = 0;
  if (Number.isFinite(hitPoints.current)) hp += hitPoints.current;
  if (Number.isFinite(hitPoints.temp)) hp += hitPoints.temp;
  return hp;
};

const attributeOptions = () => {
  let core = [
    "Strength",
    "Dexterity",
    "Constitution",
    "Intelligence",
    "Wisdom",
    "Charisma"
  ];
  let options = [];
  core.forEach(function(element) {
    options.push({ text: element, value: element.toLowerCase() });
  });
  return options;
};

let core = {
  actionTypes: actionTypes,
  itemTypes: itemTypes,
  attributeOptions: attributeOptions,
  spellSchools: spellSchools,

  getAttribute: getAttribute,
  getAttributeBonus: getAttributeBonus,
  getTotalHitPoints: getTotalHitPoints,

  ruleTypes: ruleTypes,
  ruleTypesPlural: ruleTypesPlural
};

export default core;
